<template>
    <div id="photos" class="section">
        <v-container>
            <h2>Photos</h2>
            <hr>
            <p class="text-xs-center mb-5">Maria's Photos</p>   
              <v-layout row wrap>
                 <v-flex xs12>
                    <PhotoBlock :directory="photos1.directory"  :gallery="photos1.gallery"/>
                    <hr class="my-3">
                    <PhotoBlock :directory="photos2.directory"  :gallery="photos2.gallery"/>
                 </v-flex>
              </v-layout>
        </v-container>
    </div>
</template>

<script>
import PhotoBlock from '@/components/PhotoBlock'
    export default {
      name: 'Photos',
      components: { PhotoBlock },
        data: () => ({
          photos1: {
            directory: 'gallery',
            gallery: ['d0', 'd1', 'd2', 'd3', 'd4', 'd5', 'd6', '12']
          },
          photos2: {
            directory: 'gallery',
            gallery: ['9', 'd7', '5', '4', '15', '6', '13', '14']            
          }
        })
    }
</script>

<style>
  #photos {
    margin-top: 40px;
  }
</style>

